/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     客户数据管理
  +--------------------------------------------------------------------------------------
*/

import Vue from "vue";
import { getGodInfoApi, postGodInfoApi } from "@/api/fam/famGodApi";

const mesPlanStore = {
  state: {
    axisMounths: [],
    axisDays: [],
    dispatchProcessArr: [
      { value: 1, title: "新建/导入" },
      { value: 2, title: "排产" },
      { value: 3, title: "下发" },
      { value: 4, title: "开工" },
      { value: 5, title: "完工" },
      { value: 6, title: "质检" },
      { value: 7, title: "结单" }
    ]
  },

  mutations: {
    SET_AXIS_DAY: (state, data) => {
      Vue.set(state, "axisDays", data);
    },
    SET_AXIS_MONTH: (state, data) => {
      Vue.set(state, "axisMonths", data);
    }
  },

  actions: {}
};

export default mesPlanStore;
